import * as React from "react";
import {
  useFloating,
  useDismiss,
  useRole,
  useInteractions,
  FloatingFocusManager,
  offset,
  flip,
  shift,
  useHover,
  autoUpdate,
  useFocus,
  FloatingPortal,
} from "@floating-ui/react";

const Tooltip = ({
  content,
  disabled = false,
  children,
  placement = "bottom-end",
  className = "bg-[#4E4E4E]  flex z-30 justify-center shadow-[0_3px_8px_rgba(0,0,0,0.24)] rounded-md  px-2 py-1  w-max text-[#FFFFFF] text-xs flex",
  open: controlledOpen,
  onOpenChange: setControlledOpen,
  ...props
}) => {
  const [uncontrolledOpen, setUncontrolledOpen] = React.useState(false);

  const open = controlledOpen ?? uncontrolledOpen;
  const setOpen = setControlledOpen ?? setUncontrolledOpen;

  const { refs, floatingStyles, context } = useFloating({
    placement,
    open,
    onOpenChange: setOpen,
    whileElementsMounted: autoUpdate,
    middleware: [
      offset(5),
      flip({
        crossAxis: placement.includes("-"),
        fallbackAxisSideDirection: "start",
        padding: 5,
      }),
      shift({ padding: 5 }),
    ],
  });

  const hover = useHover(context, {
    move: false,
    enabled: controlledOpen == null,
  });

  const focus = useFocus(context, {
    enabled: controlledOpen == null,
  });

  const dismiss = useDismiss(context);
  const role = useRole(context, { role: "tooltip" });

  const { getReferenceProps, getFloatingProps, getItemProps } = useInteractions(
    [role, hover, focus]
  );

  return (
    <>
      {React.isValidElement(children) &&
        React.cloneElement(
          children,
          getReferenceProps({
            ref: refs.setReference,
            ...props,
            ...children.props,
            "data-state": context.open ? "open" : "closed",
          })
        )}

      {open && !disabled && (
        <FloatingPortal>
          <FloatingFocusManager context={context} modal={false}>
            <div
              ref={refs.setFloating}
              className={className}
              role="tooltip"
              aria-orientation="vertical"
              aria-labelledby="menu-button"
              tabIndex="-1"
              style={floatingStyles}
              {...getFloatingProps()}
            >
              {content}
            </div>
          </FloatingFocusManager>
        </FloatingPortal>
      )}
    </>
  );
};
export default Tooltip;
